"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = require("@commercelayer/active-resource"),
  a = e(require("lodash/map")),
  r = e(require("lodash/isEmpty")),
  n = e(require("lodash/snakeCase")),
  s = e(require("lodash/isArray")),
  o = e(require("lodash/has")),
  i = e(require("lodash/first")),
  c = e(require("lodash/compact")),
  u = e(require("lodash/findKey")),
  l = require("lodash"),
  d = e(require("axios"));
function m() {
  return (m = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
    return e;
  }).apply(this, arguments);
}
function h(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, (Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function p(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var f = function (e, t) {
    var a = e.data;
    if (null != t && t.first) return a.data = l.isNumber(t.first) && t.first > 1 ? l.slice(a.data, 0, t.first) : i(a.data), a;
    if (null != t && t.last) {
      var r = l.reverse(a.data);
      return a.data = l.isNumber(t.last) && t.last > 1 ? l.slice(r, 0, t.last) : i(r), a;
    }
    return a;
  },
  y = function (e, t, a) {
    var r = {
      data: {
        type: t,
        attributes: {}
      }
    };
    return a && (r.data.id = a), l.forEach(e, function (e, t) {
      if (null != e && e.klass) {
        var a,
          n = l.snakeCase(e.klass().queryName),
          s = l.snakeCase(t);
        r.data.relationships = m({}, r.data.relationships, ((a = {})["" + s] = {
          data: {
            id: e.id,
            type: n
          }
        }, a));
      } else {
        var o = t.startsWith("_", 0) ? "_" + l.snakeCase(t) : l.snakeCase(t);
        r.data.attributes[o] = e;
      }
    }), r;
  },
  A = t.createResourceLibrary("https://yourdomain.commercelayer.io/api/");
A.customRequests = {};
var C = function (e) {
  function t() {
    var t;
    return p(t = e.call(this) || this) || p(t);
  }
  return h(t, e), t.setCustomFunctions = function (e) {
    return e.all = this.all, e.order = this.order, e.find = this.find, e.findBy = this.findBy, e.includeMetaInfo = this.includeMetaInfo, e.first = this.first, e.last = this.last, e.setCustomFunctions = this.setCustomFunctions, e.select = this.select, e.perPage = this.perPage, e.page = this.page, e.where = this.where, e.setInterceptors = this.setInterceptors, e.rawResponse = this.rawResponse, e.includeMetaInfo = this.includeMetaInfo, e.includes = this.includes, e.resourceLibrary = this.resourceLibrary, e.jsonapiQueryParams = this.jsonapiQueryParams, e.create = this.create, e.update = this.update, e;
  }, t.create = function (t, a) {
    var r;
    return !1 !== (null == a ? void 0 : a.rawResponse) && (0 != !(null == A || null == (r = A.options) || !r.rawResponse) || null != a && a.rawResponse) ? this.rawResponse({
      method: "post",
      data: t
    }) : this.setCustomFunctions(e.create.call(this, t));
  }, t.last = function (t, a) {
    var r;
    return !1 !== (null == a ? void 0 : a.rawResponse) && (0 != !(null == A || null == (r = A.options) || !r.rawResponse) || null != a && a.rawResponse) ? this.rawResponse({
      last: t || !0
    }) : this.setCustomFunctions(e.last.call(this, t));
  }, t.first = function (t, a) {
    var r;
    return !1 !== (null == a ? void 0 : a.rawResponse) && (0 != !(null == A || null == (r = A.options) || !r.rawResponse) || null != a && a.rawResponse) ? this.rawResponse({
      first: t || !0
    }) : this.setCustomFunctions(e.first.call(this, t));
  }, t.includes = function () {
    for (var t, a = arguments.length, r = new Array(a), n = 0; n < a; n++) r[n] = arguments[n];
    return this.setCustomFunctions((t = e.includes).call.apply(t, [this].concat(r)));
  }, t.select = function () {
    for (var t, a = arguments.length, r = new Array(a), n = 0; n < a; n++) r[n] = arguments[n];
    return this.setCustomFunctions((t = e.select).call.apply(t, [this].concat(r)));
  }, t.order = function (t) {
    return this.setCustomFunctions(e.order.call(this, t));
  }, t.page = function (t) {
    return this.setCustomFunctions(e.page.call(this, t));
  }, t.perPage = function (t) {
    return this.setCustomFunctions(e.perPage.call(this, t));
  }, t.limit = function (t) {
    return this.includeMetaInfo(this.interface().axios.interceptors), e.limit.call(this, t);
  }, t.offset = function (t) {
    return this.includeMetaInfo(this.interface().axios.interceptors), e.offset.call(this, t);
  }, t.where = function (t) {
    var a = {
      q: m({}, t)
    };
    return this.setCustomFunctions(e.where.call(this, a));
  }, t.all = function (t) {
    var a;
    return this.includeMetaInfo(this.interface().axios.interceptors), !1 !== (null == t ? void 0 : t.rawResponse) && (0 != !(null == A || null == (a = A.options) || !a.rawResponse) || null != t && t.rawResponse) ? this.rawResponse() : e.all.call(this);
  }, t.findBy = function (e) {
    var t = {};
    return Object.keys(e).map(function (a) {
      t[a + "_eq"] = e[a];
    }), this.includeMetaInfo(this.interface().axios.interceptors), this.where(t).first();
  }, t.withCredentials = function (e) {
    var t,
      a = e.accessToken,
      r = e.endpoint;
    return this.accessToken || this.endpoint || (null != (t = this.resourceLibrary.headers) && t.Authorization ? (this.accessToken = this.resourceLibrary.headers.Authorization, this.endpoint = this.resourceLibrary.baseUrl) : (this.accessToken = "Bearer ", this.endpoint = this.resourceLibrary.baseUrl)), this.resourceLibrary.headers = {
      Authorization: "Bearer " + a
    }, this.resourceLibrary.endpoint = r, this.__links = {
      related: r + "/api/" + this.queryName
    }, this.singleRequest = !0, this;
  }, t.includeMetaInfo = function (e, t) {
    void 0 === e && (e = null), void 0 === t && (t = this);
    var a = e || this.interface().axios.interceptors;
    return this.setInterceptors(a, t), this;
  }, t.jsonapiQueryParams = function (e, t) {
    if ("fields" === t) {
      var r = [];
      return a(e, function (e, o) {
        var i = e.map(function (e) {
          return s(e) ? e.map(function (e) {
            return n(e);
          }).join(",") : l.isObject(e) ? a(e, function (e, a) {
            if (s(e)) {
              var o = e.map(function (e) {
                return n(e);
              });
              r.push(t + "[" + a + "]=" + o.join(","));
            }
          }) : n(e);
        });
        return t + "[" + o + "]=" + i.join(",");
      }).concat(r).join("&");
    }
    if ("filter" === t) return a(e, function (e, r) {
      return a(e, function (e, a) {
        var s = n(a);
        return t + "[" + r + "][" + s + "]=" + e;
      }).join("&");
    });
    if ("include" === t) {
      var o = e.map(function (e) {
        return e.split(".").map(function (e) {
          return n(e);
        }).join(".");
      });
      return t + "=" + o.join(",");
    }
    if ("sort" === t) {
      var i = a(e, function (e, t) {
        return ("asc" === e.toLowerCase() ? "" : "-") + n(t);
      });
      return t + "=" + i.join(",");
    }
    return "__root" !== t ? a(e, function (e, a) {
      return t + "[" + a + "]=" + e;
    }).join("&") : void 0;
  }, t.rawResponse = function (e) {
    var t, n, s, o;
    void 0 === e && (e = {});
    var i = e.paramKey,
      u = e.method,
      l = void 0 === u ? "get" : u,
      h = e.data,
      p = e.callback,
      A = e.first,
      C = e.last;
    this.setInterceptors(d.interceptors);
    var x = c(a(this.queryParams(), this.jsonapiQueryParams)),
      g = null != this && null != (t = this.resourceLibrary) && t.endpoint ? this.resourceLibrary.endpoint : null == (n = this.resourceLibrary) ? void 0 : n.baseUrl,
      N = null != this && this.resourceLibrary ? this.resourceLibrary.headers : null == (s = this.base) || null == (o = s.resourceLibrary) ? void 0 : o.headers,
      O = i ? g.replace("/api/", "") + "/api/" + this.queryName + "/" + i : g.replace("/api/", "") + "/api/" + this.queryName;
    r(x) || (O = O + "?" + encodeURI(x.join("&")));
    var v = {
      method: l,
      url: O,
      headers: m({}, N, {
        "content-type": "application/vnd.api+json"
      })
    };
    return r(h) || (v.data = "patch" !== l ? y(h, this.queryName) : y(h, this.queryName, i)), d(v).then(function (e) {
      var t = f(e, {
        first: A,
        last: C
      });
      return p && p(t), t;
    });
  }, t.find = function (t, a) {
    var r;
    return this.includeMetaInfo(), !1 !== (null == a ? void 0 : a.rawResponse) && (0 != !(null == A || null == (r = A.options) || !r.rawResponse) || null != a && a.rawResponse) ? this.rawResponse({
      paramKey: t
    }) : e.find.call(this, t);
  }, t.setCustomInterceptors = function (e) {
    return A.customInterceptors = e, this;
  }, t.setInterceptors = function (e, t) {
    var a = this,
      n = null == e ? void 0 : e.response,
      c = null == n ? void 0 : n.handlers;
    (null == e ? void 0 : e.request).use(function (e) {
      var t, a;
      return r(e.params) || (e.params = function (e) {
        if (r(e.filter) || o(e.filter, "q") || (e.filter = {
          q: e.filter
        }), !r(e.fields) && !r(e.include)) {
          var t = e.include.split(","),
            a = u(e.fields, function (t) {
              return !r(e.include) && -1 !== t.search(e.include);
            }),
            n = e.fields[a].split(",").map(function (e) {
              return t.includes(e) ? i(e.split(".")) : e;
            }).join(",");
          e.fields[a] = n;
        }
        return e;
      }(e.params)), !r(null == A || null == (t = A.customInterceptors) ? void 0 : t.request) && o(null == A || null == (a = A.customInterceptors) ? void 0 : a.request, "before") ? A.customInterceptors.request.before(e) : e;
    }, function (e) {
      var t, a;
      return !r(null == A || null == (t = A.customInterceptors) ? void 0 : t.request) && o(null == A || null == (a = A.customInterceptors) ? void 0 : a.request, "error") ? A.customInterceptors.request.error(e) : Promise.reject(e);
    }), (1 === (null == c ? void 0 : c.length) || r(c)) && (n.handlers.shift(), n.use(function (e) {
      var t, n;
      if (!e.data) return e;
      var i = s(e.data.data) ? e.data.meta : e.data.data.meta,
        c = A.interface.toCamelCase(i);
      a.meta = c;
      var u = function (e) {
        return e.lastIndexOf("/") + 1 === e.length ? e.substring(0, e.length - 1) : e;
      }(e.config.url);
      return A.customRequests = {}, A.customRequests[u] = m({}, e.data, {
        headers: e.headers,
        collectionParent: a
      }), !r(null == A || null == (t = A.customInterceptors) ? void 0 : t.response) && o(null == A || null == (n = A.customInterceptors) ? void 0 : n.response, "before") ? A.customInterceptors.response.before(e) : e;
    }, function (e) {
      var t, a;
      return !r(null == A || null == (t = A.customInterceptors) ? void 0 : t.response) && o(null == A || null == (a = A.customInterceptors) ? void 0 : a.response, "error") ? A.customInterceptors.response.error(e) : Promise.reject(e);
    }));
  }, t;
}(A.Base);
C.accessToken = "", C.endpoint = "", C.singleRequest = !1, C.meta = {}, C.__queryParams = {}, C.afterBuild(function () {
  delete this.__meta, delete this.__collectionMeta, delete this.__headers;
}), C.afterRequest(function () {
  var e;
  e = this, a(A.customRequests, function (t) {
    if (r(t.headers) || e.setHeaders(t.headers), s(t.data)) {
      var a = i(t.data.filter(function (t) {
        return e.id === t.id;
      }));
      if (!r(a)) {
        var n = A.interface.toCamelCase(t.meta),
          o = A.interface.toCamelCase(a.meta);
        e.setMetaInfo(o), e.setCollectionMetaInfo(n);
      }
    } else {
      var c = A.interface.toCamelCase(t.data.meta);
      e.setMetaInfo(c);
    }
  }), this.constructor.singleRequest && (this.constructor.resourceLibrary.baseUrl = this.constructor.endpoint, this.constructor.resourceLibrary.headers = {
    Authorization: this.constructor.accessToken
  }, this.constructor.__links = null, this.constructor.singleRequest = !1);
}), t.CollectionResponse.prototype.getMetaInfo = function () {
  var e = this.first();
  return r(e) ? {} : o(e, "__collectionMeta") ? e.__collectionMeta : e.getMetaInfo();
}, t.CollectionResponse.prototype.getHeaders = function () {
  var e = this.first();
  return r(e) ? {} : o(e, "__headers") ? e.__headers : e.getHeaders();
}, t.CollectionResponse.prototype.pageCount = function () {
  var e = i(this.toArray());
  return r(e) ? 0 : o(e, "__collectionMeta.pageCount") ? e.__collectionMeta.pageCount : this.first().pageCount();
}, t.CollectionResponse.prototype.recordCount = function () {
  var e = i(this.toArray());
  return r(e) ? 0 : o(e, "__collectionMeta.recordCount") ? e.__collectionMeta.recordCount : this.first().recordCount();
}, t.CollectionResponse.prototype.withCredentials = function (e) {
  return A.headers = {
    Authorization: "Bearer " + e.accessToken
  }, A.singleRequest = !0, this;
}, A.Base = C;
var x = function (e) {
    function t() {
      var t;
      return (t = e.call(this) || this).__meta = {}, t.__collectionMeta = {}, t.__headers = {}, p(t) || p(t);
    }
    h(t, e);
    var a = t.prototype;
    return a.getMetaInfo = function () {
      return this.__meta;
    }, a.getHeaders = function () {
      return this.__headers;
    }, a.pageCount = function () {
      return this.__meta.pageCount;
    }, a.recordCount = function () {
      return this.__meta.recordCount;
    }, a.mode = function () {
      return this.__meta.mode;
    }, a.setMetaInfo = function (e) {
      return this.__meta = e;
    }, a.setHeaders = function (e) {
      return this.__headers = e;
    }, a.setCollectionMetaInfo = function (e) {
      return this.__collectionMeta = e;
    }, a.klass = function () {
      var t = e.prototype.klass.call(this).interface().axios.interceptors;
      return this.constructor.includeMetaInfo(t), e.prototype.klass.call(this);
    }, a.association = function (t) {
      var a = e.prototype.association.call(this, t).interface().axios.interceptors;
      return this.constructor.includeMetaInfo(a), e.prototype.association.call(this, t);
    }, a.update = function (t, a, r) {
      var n;
      return !1 !== (null == r ? void 0 : r.rawResponse) && (0 != !(null == A || null == (n = A.options) || !n.rawResponse) || null != r && r.rawResponse) ? this.constructor.rawResponse({
        data: t,
        method: "patch",
        paramKey: this.id,
        callback: a
      }) : e.prototype.update.call(this, t, a);
    }, a.withCredentials = function (e) {
      var t,
        a = e.accessToken,
        r = e.endpoint;
      return this.constructor.includeMetaInfo(), this.constructor.accessToken || this.constructor.endpoint || (null != (t = this.constructor.resourceLibrary.headers) && t.Authorization ? (this.constructor.accessToken = this.constructor.resourceLibrary.headers.Authorization, this.constructor.endpoint = this.constructor.resourceLibrary.baseUrl) : (this.constructor.accessToken = "Bearer ", this.constructor.endpoint = this.constructor.resourceLibrary.baseUrl)), this.constructor.resourceLibrary.headers = {
        Authorization: "Bearer " + a
      }, this.__links = {
        related: r + "/api/" + this.constructor.queryName,
        self: r + "/api/" + this.constructor.queryName + "/" + this.id
      }, this.constructor.singleRequest = !0, this;
    }, a.setCustomInterceptors = function (e) {
      return this.constructor.customInterceptors = e, this;
    }, t;
  }(A.Base),
  g = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("business", "firstName", "lastName", "company", "fullName", "line1", "line2", "city", "zipCode", "stateCode", "countryCode", "phone", "fullAddress", "name", "email", "notes", "lat", "lng", "isLocalized", "isGeocoded", "providerName", "mapUrl", "staticMapUrl", "billingInfo", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("geocoder", {
        className: "Geocoder"
      });
    }, t;
  }(x);
g.className = "Address";
var N = A.createResource(g),
  O = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "description", "url", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.belongsTo("attachable", {
        polymorphic: !0
      });
    }, t;
  }(x);
O.className = "Attachment";
var v = A.createResource(O);
v.afterBuild(function () {
  this.attachableId && delete this.attachableId, this.attachableType && delete this.attachableType;
});
var R = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return h(t, e), t.define = function () {
    this.attributes("name", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("customer", {
      className: "Customer"
    }), this.hasOne("address", {
      className: "Address"
    });
  }, t;
}(x);
R.className = "CustomerAddress";
var k = A.createResource(R),
  b = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("priceList", {
        className: "PriceList"
      }), this.hasMany("customers", {
        className: "Customer"
      });
    }, t;
  }(x);
b.className = "CustomerGroup";
var P = A.createResource(b),
  S = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("customerEmail", "resetPasswordToken", "customerPassword", "_resetPasswordToken", "resetPasswordAt", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("customer", {
        className: "Customer"
      });
    }, t;
  }(x);
S.className = "CustomerPasswordReset";
var M = A.createResource(S),
  I = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("customer", {
        className: "Customer"
      }), this.belongsTo("paymentSource", {
        polymorphic: !0
      });
    }, t;
  }(x);
I.className = "CustomerPaymentSource";
var L = A.createResource(I);
L.afterBuild(function () {
  this.paymentSourceId && delete this.paymentSourceId, this.paymentSourceType && delete this.paymentSourceType;
});
var T = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return h(t, e), t.define = function () {
    this.attributes("customerEmail", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("customer", {
      className: "Customer"
    });
  }, t;
}(x);
T.className = "CustomerSubscription";
var _ = A.createResource(T),
  w = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("email", "hasPassword", "password", "passwordBlank", "passwordPresent", "status", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("customerGroup", {
        className: "CustomerGroup"
      }), this.hasMany("customerAddresses", {
        className: "CustomerAddress"
      }), this.hasMany("customerPaymentSources", {
        className: "CustomerPaymentSource"
      }), this.hasMany("customerSubscriptions", {
        className: "CustomerSubscription"
      }), this.hasMany("orders", {
        className: "Order"
      });
    }, t;
  }(x);
w.className = "Customer";
var F = A.createResource(w),
  G = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("minHours", "maxHours", "minDays", "maxDays", "id", "createdAt", "updatedAt", "referenceOrigin", "metadata"), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("shippingMethod", {
        className: "ShippingMethod"
      });
    }, t;
  }(x);
G.className = "DeliveryLeadTime";
var q = A.createResource(G),
  B = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("resourceType", "parentResourceId", "status", "startedAt", "completedAt", "inputs", "errorsCount", "warningsCount", "destroyedCount", "errorsLog", "warningsLog", "cleanupRecords", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata");
    }, t;
  }(x);
B.className = "Import";
var U = A.createResource(B),
  j = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("status", "customerEmail", "skuCode", "_activate", "_deactivate", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("customer", {
        className: "Customer"
      }), this.hasOne("sku", {
        className: "Sku"
      });
    }, t;
  }(x);
j.className = "InStockSubscription";
var D = A.createResource(j),
  E = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "id", "stockLocationsCutoff", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasMany("inventoryStockLocations", {
        className: "InventoryStockLocation"
      });
    }, t;
  }(x);
E.className = "InventoryModel";
var z = A.createResource(E),
  W = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "quantity", "currencyCode", "unitAmountCents", "unitAmountFloat", "formattedUnitAmount", "totalAmountCents", "totalAmountFloat", "formattedTotalAmount", "delayHours", "delayDays", "options", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("lineItem", {
        className: "LineItem"
      }), this.hasOne("skuOption", {
        className: "SkuOption"
      });
    }, t;
  }(x);
W.className = "LineItemOption";
var H = A.createResource(W),
  V = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("skuCode", "quantity", "_updateQuantity", "currencyCode", "unitAmountCents", "unitAmountFloat", "formattedUnitAmount", "optionsAmountCents", "optionsAmountFloat", "formattedOptionsAmount", "totalAmountCents", "totalAmountFloat", "formattedTotalAmount", "name", "imageUrl", "taxRate", "taxBreakdown", "itemType", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.belongsTo("item", {
        polymorphic: !0
      }), this.hasMany("lineItemOptions", {
        className: "LineItemOption"
      });
    }, t;
  }(x);
V.className = "LineItem";
var K = A.createResource(V);
K.afterBuild(function () {
  this.itemId && delete this.itemId, this.itemType && delete this.itemType;
});
var Z = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return h(t, e), t.define = function () {
    this.attributes("number", "name", "facebookPixelId", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("merchant", {
      className: "Merchant"
    }), this.hasOne("priceList", {
      className: "PriceList"
    }), this.hasOne("inventoryModel", {
      className: "InventoryModel"
    }), this.hasMany("customerGroup", {
      className: "CustomerGroup"
    });
  }, t;
}(x);
Z.className = "Market";
var Q = A.createResource(Z),
  J = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("address", {
        className: "Address"
      });
    }, t;
  }(x);
J.className = "Merchant";
var X = A.createResource(J),
  Y = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("_archive", "_unarchive", "_approve", "_billingAddressCloneId", "_billingAddressSameAsShipping", "_cancel", "_capture", "_customerPaymentSourceId", "_place", "_refresh", "_refund", "_saveBillingAddressToCustomerAddressBook", "_savePaymentSourceToCustomerWallet", "_saveShippingAddressToCustomerAddressBook", "_shippingAddressCloneId", "_shippingAddressSameAsBilling", "_updateTaxes", "adjustmentAmountCents", "adjustmentAmountFloat", "adjustmentTaxAmountCents", "adjustmentTaxAmountFloat", "approvedAt", "archivedAt", "cancelledAt", "cartUrl", "checkoutUrl", "countryCode", "couponCode", "createdAt", "currencyCode", "customerEmail", "customerPassword", "discountAmountCents", "discountAmountFloat", "discountTaxAmountCents", "discountTaxAmountFloat", "discountTaxableAmountCents", "discountTaxableAmountFloat", "editable", "feesAmountCents", "feesAmountFloat", "formattedAdjustmentAmount", "formattedAdjustmentTaxAmount", "formattedDiscountAmount", "formattedDiscountTaxAmount", "formattedDiscountTaxableAmount", "formattedFeesAmount", "formattedGiftCardAmount", "formattedPaymentMethodAmount", "formattedPaymentMethodTaxAmount", "formattedPaymentMethodTaxableAmount", "formattedShippingAmount", "formattedShippingTaxAmount", "formattedShippingTaxableAmount", "formattedSubtotalAmount", "formattedSubtotalTaxAmount", "formattedSubtotalTaxableAmount", "formattedTotalAmount", "formattedTotalAmountWithTaxes", "formattedTotalTaxAmount", "formattedTotalTaxableAmount", "freightTaxable", "fulfillmentStatus", "fulfillmentUpdatedAt", "giftCardAmountCents", "giftCardAmountFloat", "giftCardCode", "giftCardOrCouponCode", "guest", "id", "languageCode", "lineItemOptionsCount", "metadata", "number", "paymentMethodAmountCents", "paymentMethodAmountFloat", "paymentMethodTaxAmountCents", "paymentMethodTaxAmountFloat", "paymentMethodTaxableAmountCents", "paymentMethodTaxableAmountFloat", "paymentSourceDetails", "paymentStatus", "paymentUpdatedAt", "placeable", "placedAt", "privacyUrl", "reference", "referenceOrigin", "returnUrl", "shipmentsCount", "shippingAmountCents", "shippingAmountFloat", "shippingCountryCodeLock", "shippingTaxAmountCents", "shippingTaxAmountFloat", "shippingTaxableAmountCents", "shippingTaxableAmountFloat", "skusCount", "status", "subtotalAmountCents", "subtotalAmountFloat", "subtotalTaxAmountCents", "subtotalTaxAmountFloat", "subtotalTaxableAmountCents", "subtotalTaxableAmountFloat", "taxIncluded", "taxRate", "termsUrl", "token", "totalAmountCents", "totalAmountFloat", "totalAmountWithTaxesCents", "totalAmountWithTaxesFloat", "totalTaxAmountCents", "totalTaxAmountFloat", "totalTaxableAmountCents", "totalTaxableAmountFloat", "updatedAt"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("customer", {
        className: "Customer"
      }), this.hasOne("shippingAddress", {
        className: "Address"
      }), this.hasOne("billingAddress", {
        className: "Address"
      }), this.hasOne("paymentMethod", {
        className: "PaymentMethod"
      }), this.hasMany("availablePaymentMethods", {
        className: "PaymentMethod"
      }), this.hasMany("lineItems", {
        className: "LineItem"
      }), this.hasMany("shipments", {
        className: "Shipment"
      }), this.hasMany("transactions", {
        className: "Transaction"
      }), this.hasMany("authorizations", {
        className: "Authorization"
      }), this.hasMany("captures", {
        className: "Capture"
      }), this.hasMany("voids", {
        className: "Void"
      }), this.hasMany("refunds", {
        className: "Refund"
      }), this.hasMany("availableCustomerPaymentSources", {
        className: "CustomerPaymentSource"
      }), this.belongsTo("paymentSource", {
        polymorphic: !0
      });
    }, t;
  }(x);
Y.className = "Order";
var $ = A.createResource(Y);
$.afterBuild(function () {
  this.paymentSourceId && delete this.paymentSourceId, this.paymentSourceType && delete this.paymentSourceType;
});
var ee = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  return h(t, e), t.define = function () {
    this.attributes("number", "weight", "unitOfWeight", "eelPfc", "contentsType", "contentsExplanation", "customsCertify", "customsSigner", "nonDeliveryOption", "restrictionType", "restrictionComments", "customsInfoRequired", "shippingLabelUrl", "shippingLabelFileType", "shippingLabelSize", "shippingLabelResolution", "trackingNumber", "trackingStatus", "trackingStatusDetail", "trackingStatusUpdatedAt", "trackingDetails", "carrierWeightOz", "signedBy", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("shipment", {
      className: "Shipment"
    }), this.hasMany("parcelLineItems", {
      className: "LineItem"
    });
  }, t;
}(x);
ee.className = "Parcel";
var te = A.createResource(ee),
  ae = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("paymentSourceType", "name", "disabledAt", "priceAmountCents", "priceAmountFloat", "formattedPriceAmount", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("paymentGateway", {
        className: "PaymentGateway"
      });
    }, t;
  }(x);
ae.className = "PaymentMethod";
var re = A.createResource(ae),
  ne = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("id");
    }, t;
  }(x);
ne.className = "PaymentGateway";
var se = A.createResource(ne),
  oe = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("returnUrl", "cancelUrl", "noteToPayer", "paypalPayerId", "name", "paypalId", "status", "approvalUrl", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
oe.className = "PaypalPayment";
var ie = A.createResource(oe),
  ce = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("currencyCode", "skuCode", "amountCents", "amountFloat", "formattedAmount", "compareAtAmountCents", "compareAtAmountFloat", "formattedCompareAtAmount", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("priceList", {
        className: "PriceList"
      }), this.hasOne("sku", {
        className: "Sku"
      });
    }, t;
  }(x);
ce.className = "Price";
var ue = A.createResource(ce),
  le = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "currencyCode", "taxIncluded", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasMany("prices", {
        className: "Price"
      });
    }, t;
  }(x);
le.className = "PriceList";
var de = A.createResource(le),
  me = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "status", "currencyCode", "costAmountCents", "costAmountFloat", "formattedCostAmount", "_onHold", "_picking", "_packing", "_readyToShip", "_ship", "_getRates", "selectedRateId", "_purchase", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("shippingCategory", {
        className: "ShippingCategory"
      }), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("shippingAddress", {
        className: "Address"
      }), this.hasOne("shippingMethod", {
        className: "ShippingMethod"
      }), this.hasOne("deliveryLeadTime", {
        className: "DeliveryLeadTime"
      }), this.hasMany("shipmentLineItems", {
        className: "ShipmentLineItem"
      }), this.hasMany("availableShippingMethods", {
        className: "ShippingMethod"
      }), this.hasMany("parcels", {
        className: "Parcel"
      }), this.hasMany("attachments", {
        className: "Attachment"
      }), this.hasMany("stockTransfers", {
        className: "StockTransfer"
      });
    }, t;
  }(x);
me.className = "Shipment";
var he = A.createResource(me),
  pe = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "id", "createdAt", "updatedAt", "referenceOrigin", "metadata"), this.hasMany("skus", {
        className: "Sku"
      });
    }, t;
  }(x);
pe.className = "ShippingCategory";
var fe = A.createResource(pe),
  ye = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "disabledAt", "currencyCode", "priceAmountCents", "priceAmountFloat", "formattedPriceAmount", "freeOverAmountCents", "freeOverAmountFloat", "formattedFreeOverAmount", "priceAmountForShipmentCents", "priceAmountForShipmentFloat", "formattedPriceAmountForShipment", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("shippingZone", {
        className: "ShippingZone"
      }), this.hasOne("shippingCategory", {
        className: "ShippingCategory"
      }), this.hasOne("deliveryLeadTimeForShipment", {
        className: "DeliveryLeadTime"
      });
    }, t;
  }(x);
ye.className = "ShippingMethod";
var Ae = A.createResource(ye),
  Ce = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "countryCodeRegex", "notCountryCodeRegex", "stateCodeRegex", "notStateCodeRegex", "zipCodeRegex", "notZipCodeRegex", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata");
    }, t;
  }(x);
Ce.className = "ShippingZone";
var xe = A.createResource(Ce),
  ge = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "description", "priceAmountCents", "priceAmountFloat", "formattedPriceAmount", "delayHours", "delayDays", "skuCodeRegex", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      });
    }, t;
  }(x);
ge.className = "SkuOption";
var Ne = A.createResource(ge),
  Oe = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("code", "createdAt", "description", "doNotShip", "doNotTrack", "hsTariffNumber", "id", "imageUrl", "inventory", "metadata", "name", "piecesPerPack", "reference", "referenceOrigin", "unitOfWeight", "updatedAt", "weight"), this.hasOne("shippingCategory", {
        className: "ShippingCategory"
      }), this.hasMany("prices", {
        className: "Price"
      }), this.hasMany("stockItems", {
        className: "StockItem"
      }), this.hasMany("deliveryLeadTimes", {
        className: "DeliveryLeadTime"
      }), this.hasMany("skuOptions", {
        className: "SkuOption"
      }), this.hasMany("attachments", {
        className: "Attachment"
      });
    }, t;
  }(x);
Oe.className = "Sku";
var ve = A.createResource(Oe),
  Re = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "slug", "description", "manual", "skuCodeRegex", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasMany("skus", {
        className: "Sku"
      }), this.hasMany("skuListItems", {
        className: "SkuListItem"
      });
    }, t;
  }(x);
Re.className = "SkuList";
var ke = A.createResource(Re),
  be = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("position", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("sku", {
        className: "Sku"
      }), this.hasOne("skuList", {
        className: "SkuList"
      });
    }, t;
  }(x);
be.className = "SkuListItem";
var Pe = A.createResource(be),
  Se = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("skuCode", "quantity", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("sku", {
        className: "Sku"
      });
    }, t;
  }(x);
Se.className = "StockItem";
var Me = A.createResource(Se),
  Ie = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("priority", "onHold", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("inventoryModel", {
        className: "InventoryModel"
      });
    }, t;
  }(x);
Ie.className = "InventoryStockLocation";
var Le = A.createResource(Ie),
  Te = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "labelFormat", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("address", {
        className: "Address"
      }), this.hasMany("InventoryStockLocations", {
        className: "InventoryStockLocation"
      }), this.hasMany("stockItems", {
        className: "StockItem"
      });
    }, t;
  }(x);
Te.className = "StockLocation";
var _e = A.createResource(Te),
  we = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("topic", "callbackUrl", "includeResources", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata");
    }, t;
  }(x);
we.className = "Webhook";
var Fe = A.createResource(we),
  Ge = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
Ge.className = "WireTransfer";
var qe = A.createResource(Ge),
  Be = function (e) {
    var t = e.accessToken,
      a = e.interceptors,
      r = e.options;
    A.baseUrl = e.endpoint + "/api/", A.headers = {
      Authorization: "Bearer " + t
    }, A.customInterceptors = a, A.options = r || {
      rawResponse: !1
    };
  },
  Ue = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes();
    }, t;
  }(x);
Ue.className = "Geocoder";
var je = A.createResource(Ue),
  De = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {}, t;
  }(x);
De.className = "PaymentSource";
var Ee = A.createResource(De),
  ze = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("status", "code", "currencyCode", "initialBalanceCents", "initialBalanceFloat", "formattedInitialBalance", "balanceCents", "balanceFloat", "formattedBalance", "balanceMaxCents", "balanceMaxFloat", "formattedBalanceMax", "balanceLog", "singleUse", "rechargeable", "imageUrl", "expiresAt", "referenceOrigin", "recipientEmail", "_purchase", "_activate", "_deactivate", "_balanceChangeCents", "id", "createAt", "updateAt", "reference", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("giftCardRecipient", {
        className: "GiftCardRecipient"
      });
    }, t;
  }(x);
ze.className = "GiftCard";
var We = A.createResource(ze),
  He = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("email", "firstName", "lastName", "referenceOrigin", "id", "createAt", "updateAt", "reference", "metadata"), this.hasOne("customer", {
        className: "Customer"
      });
    }, t;
  }(x);
He.className = "GiftCardRecipient";
var Ve = A.createResource(He),
  Ke = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("paymentMethod", "paymentRequestData", "paymentRequestDetails", "paymentResponse", "_authorize", "_details", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
Ke.className = "AdyenPayment";
var Ze = A.createResource(Ke),
  Qe = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("clientToken", "paymentMethodNonce", "options", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
Qe.className = "BraintreePayment";
var Je = A.createResource(Qe),
  Xe = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("clientSecret", "options", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
Xe.className = "StripePayment";
var Ye = A.createResource(Xe),
  $e = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "options", "paymentSourceToken", "reference", "referenceOrigin", "updatedAt"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
$e.className = "ExternalPayment";
var et = A.createResource($e),
  tt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("code", "createdAt", "length", "metadata", "name", "reference", "referenceOrigin", "unitOfLength", "updatedAt", "width"), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasMany("parcels", {
        className: "Parcel"
      });
    }, t;
  }(x);
tt.className = "Package";
var at = A.createResource(tt),
  rt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata");
    }, t;
  }(x);
rt.className = "Adjustment";
var nt = A.createResource(rt),
  st = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "succeeded", "message", "errorCode", "errorDetail", "token", "gatewayTransactionId", "_refund", "_refundAmountCents", "refundAmountCents", "refundAmountFloat", "formattedRefundAmount", "refundBalanceCents", "refundBalanceFloat", "formattedRefundBalance", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasOne("referenceAuthorization", {
        className: "Authorization"
      }), this.hasMany("refunds", {
        className: "Refund"
      });
    }, t;
  }(x);
st.className = "Capture";
var ot = A.createResource(st),
  it = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "succeeded", "message", "errorCode", "errorDetail", "cvvCode", "cvvMessage", "avsCode", "avsMessage", "fraudReview", "gatewayTransactionId", "_capture", "_captureAmountCents", "captureAmountCents", "captureAmountFloat", "formattedCaptureAmount", "captureBalanceCents", "captureBalanceFloat", "formattedCaptureBalance", "_void", "voidBalanceCents", "voidBalanceFloat", "formattedVoidBalance", "name", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasMany("captures", {
        className: "Capture"
      }), this.hasMany("voids", {
        className: "Void"
      });
    }, t;
  }(x);
it.className = "Authorization";
var ct = A.createResource(it),
  ut = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      });
    }, t;
  }(x);
ut.className = "BillingInfoValidationRule";
var lt = A.createResource(ut),
  dt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "succeeded", "message", "errorCode", "errorDetail", "token", "gatewayTransactionId", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasOne("referenceCapture", {
        className: "Capture"
      });
    }, t;
  }(x);
dt.className = "Refund";
var mt = A.createResource(dt),
  ht = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "succeeded", "message", "errorCode", "errorDetail", "token", "gatewayTransactionId", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasOne("referenceAuthorization", {
        className: "Authorization"
      });
    }, t;
  }(x);
ht.className = "Void";
var pt = A.createResource(ht),
  ft = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("promotion", {
        className: "Promotion"
      });
    }, t;
  }(x);
ft.className = "CouponCodesPromotionRule";
var yt = A.createResource(ft),
  At = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("code", "usageLimit", "usageCount", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("promotionRule", {
        className: "PromotionRule"
      });
    }, t;
  }(x);
At.className = "Coupon";
var Ct = A.createResource(At),
  xt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "startsAt", "expiresAt", "totalUsageLimit", "totalUsageCount", "active", "promotionUrl", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("orderAmountPromotionRule", {
        className: "OrderAmountPromotionRule"
      }), this.hasOne("skuListPromotionRule", {
        className: "SkuListPromotionRule"
      }), this.hasOne("couponCodesPromotionRule", {
        className: "CouponCodesPromotionRule"
      }), this.hasMany("promotionRules", {
        className: "PromotionRule"
      });
    }, t;
  }(x);
xt.className = "ExternalPromotion";
var gt = A.createResource(xt),
  Nt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "startsAt", "expiresAt", "totalUsageLimit", "totalUsageCount", "active", "fixedAmountCents", "fixedAmountFloat", "formattedFixedAmount", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("orderAmountPromotionRule", {
        className: "OrderAmountPromotionRule"
      }), this.hasOne("skuListPromotionRule", {
        className: "SkuListPromotionRule"
      }), this.hasOne("couponCodesPromotionRule", {
        className: "CouponCodesPromotionRule"
      }), this.hasMany("promotionRules", {
        className: "PromotionRule"
      });
    }, t;
  }(x);
Nt.className = "FixedAmountPromotion";
var Ot = A.createResource(Nt),
  vt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "startsAt", "expiresAt", "totalUsageLimit", "totalUsageCount", "active", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("orderAmountPromotionRule", {
        className: "OrderAmountPromotionRule"
      }), this.hasOne("skuListPromotionRule", {
        className: "SkuListPromotionRule"
      }), this.hasOne("couponCodesPromotionRule", {
        className: "CouponCodesPromotionRule"
      }), this.hasMany("promotionRules", {
        className: "PromotionRule"
      });
    }, t;
  }(x);
vt.className = "FreeShippingPromotion";
var Rt = A.createResource(vt),
  kt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("orderAmountCents", "orderAmountFloat", "formattedOrderAmount", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("promotion", {
        className: "Promotion"
      });
    }, t;
  }(x);
kt.className = "OrderAmountPromotionRule";
var bt = A.createResource(kt),
  Pt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "startsAt", "expiresAt", "totalUsageLimit", "totalUsageCount", "active", "percentage", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("orderAmountPromotionRule", {
        className: "OrderAmountPromotionRule"
      }), this.hasOne("skuListPromotionRule", {
        className: "SkuListPromotionRule"
      }), this.hasOne("skuList", {
        className: "SkuList"
      }), this.hasOne("couponCodesPromotionRule", {
        className: "CouponCodesPromotionRule"
      }), this.hasMany("promotionRules", {
        className: "PromotionRule"
      }), this.hasMany("skus", {
        className: "Sku"
      });
    }, t;
  }(x);
Pt.className = "PercentageDiscountPromotion";
var St = A.createResource(Pt),
  Mt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("promotion", {
        className: "Promotion"
      });
    }, t;
  }(x);
Mt.className = "PromotionRule";
var It = A.createResource(Mt),
  Lt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "startsAt", "expiresAt", "totalUsageLimit", "totalUsageCount", "active", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("market", {
        className: "Market"
      }), this.hasOne("orderAmountPromotionRule", {
        className: "OrderAmountPromotionRule"
      }), this.hasOne("skuListPromotionRule", {
        className: "SkuListPromotionRule"
      }), this.hasOne("couponCodesPromotionRule", {
        className: "CouponCodesPromotionRule"
      }), this.hasMany("promotionRules", {
        className: "PromotionRule"
      });
    }, t;
  }(x);
Lt.className = "Promotion";
var Tt = A.createResource(Lt),
  _t = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("promotion", {
        className: "Promotion"
      }), this.hasOne("skuList", {
        className: "SkuList"
      }), this.hasMany("skus", {
        className: "Sku"
      });
    }, t;
  }(x);
_t.className = "SkuListPromotionRule";
var wt = A.createResource(_t),
  Ft = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("priority", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("inventoryModel", {
        className: "InventoryModel"
      });
    }, t;
  }(x);
Ft.className = "InventoryReturnLocation";
var Gt = A.createResource(Ft),
  qt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "customerEmail", "status", "skusCount", "approvedAt", "rejectedAt", "shippedAt", "receivedAt", "archivedAt", "_request", "_approve", "_reject", "_ship", "_receive", "_restock", "_archive", "_unarchive", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasOne("customer", {
        className: "Customer"
      }), this.hasOne("inventoryReturnLocation", {
        className: "InventoryReturnLocation"
      }), this.hasOne("stockLocation", {
        className: "StockLocation"
      }), this.hasOne("originAddress", {
        className: "Address"
      }), this.hasOne("destinationAddress", {
        className: "Address"
      }), this.hasMany("returnLineItems", {
        className: "ReturnLineItem"
      }), this.hasMany("attachments", {
        className: "Attachment"
      });
    }, t;
  }(x);
qt.className = "Return";
var Bt = A.createResource(qt),
  Ut = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt", "taxCalculatorUrl"), this.hasMany("taxCategories", {
        className: "TaxCategory"
      });
    }, t;
  }(x);
Ut.className = "ExternalTaxCalculator";
var jt = A.createResource(Ut),
  Dt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt"), this.hasMany("taxCategories", {
        className: "TaxCategory"
      }), this.hasMany("taxRules", {
        className: "TaxRule"
      });
    }, t;
  }(x);
Dt.className = "ManualTaxCalculator";
var Et = A.createResource(Dt),
  zt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt"), this.hasMany("taxCategories", {
        className: "TaxCategory"
      });
    }, t;
  }(x);
zt.className = "TaxCalculator";
var Wt = A.createResource(zt),
  Ht = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("adjustmentTaxable", "breakDown", "countryCodeRegex", "createdAt", "freightTaxable", "giftCardTaxable", "id", "metadata", "name", "notCountryCodeRegex", "notStateCodeRegex", "notZipCodeRegex", "paymentMethodTaxable", "reference", "referenceOrigin", "stateCodeRegex", "taxRate", "updatedAt", "zipCodeRegex"), this.hasOne("manualTaxCalculator", {
        className: "ManualTaxCalculator"
      });
    }, t;
  }(x);
Ht.className = "TaxRule";
var Vt = A.createResource(Ht),
  Kt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("apiKey", "createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt"), this.hasMany("taxCategories", {
        className: "TaxCategory"
      });
    }, t;
  }(x);
Kt.className = "TaxjarAccount";
var Zt = A.createResource(Kt),
  Qt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("skuCode", "name", "quantity", "_restock", "returnReason", "restockedAt", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("return", {
        className: "Return"
      }), this.hasOne("lineItem", {
        className: "LineItem"
      });
    }, t;
  }(x);
Qt.className = "ReturnLineItem";
var Jt = A.createResource(Qt),
  Xt = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("skuCode", "quantity", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("stockItem", {
        className: "StockItem"
      }), this.hasOne("lineItem", {
        className: "LineItem"
      }), this.hasOne("shipment", {
        className: "Shipment"
      });
    }, t;
  }(x);
Xt.className = "ShipmentLineItem";
var Yt = A.createResource(Xt),
  $t = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("code", "createdAt", "id", "metadata", "reference", "referenceOrigin", "skuCode", "updatedAt"), this.hasOne("sku", {
        className: "Sku"
      }), this.hasOne("taxCalculator", {
        className: "TaxCalculator"
      });
    }, t;
  }(x);
$t.className = "TaxCategory";
var ea = A.createResource($t),
  ta = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("_cancel", "_complete", "_inTransit", "_picking", "_upcoming", "cancelledAt", "completedAt", "createdAt", "id", "metadata", "quantity", "reference", "referenceOrigin", "skuCode", "status", "updatedAt"), this.hasOne("sku", {
        className: "Sku"
      }), this.hasOne("originStockLocation", {
        className: "StockLocation"
      }), this.hasOne("destinationStockLocation", {
        className: "StockLocation"
      }), this.hasOne("shipment", {
        className: "Shipment"
      }), this.hasOne("lineItem", {
        className: "LineItem"
      });
    }, t;
  }(x);
ta.className = "StockTransfer";
var aa = A.createResource(ta),
  ra = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("companyCode", "createdAt", "createdAt", "ddp", "id", "metadata", "name", "password", "reference", "referenceOrigin", "updatedAt"), this.hasMany("taxCategories", {
        className: "TaxCategory"
      });
    }, t;
  }(x);
ra.className = "AvalaraAccount";
var na = A.createResource(ra),
  sa = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("acceptanceDisabled", "accountDisabled", "contrastColor", "createdAt", "discountDisabled", "domain", "faviconUrl", "gtmId", "gtmIdTest", "logoUrl", "metadata", "name", "primaryColor", "reference", "referenceOrigin", "slug", "updatedAt");
    }, t;
  }(x);
sa.className = "Organization", sa.queryName = "organization";
var oa = A.createResource(sa),
  ia = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("name", "kind", "publicAccess", "redirectUri", "uid", "secret", "scopes", "createdAt", "reference", "referenceOrigin", "updatedAt", "id", "metadata");
    }, t;
  }(x);
ia.className = "Application", ia.queryName = "application";
var ca = A.createResource(ia),
  ua = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("number", "currencyCode", "amountCents", "amountFloat", "formattedAmount", "succeeded", "message", "errorCode", "errorDetail", "token", "gatewayTransactionId", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      });
    }, t;
  }(x);
ua.className = "Transaction";
var la = A.createResource(ua),
  da = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "options", "paymentSourceToken", "reference", "referenceOrigin", "updatedAt"), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      }), this.hasMany("externalPayments", {
        className: "ExternalPayment"
      });
    }, t;
  }(x);
da.className = "ExternalGateway";
var ma = A.createResource(da),
  ha = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("parcel", {
        className: "Parcel"
      }), this.hasOne("shipmentLineItem", {
        className: "ShipmentLineItem"
      });
    }, t;
  }(x);
ha.className = "ParcelLineItem";
var pa = A.createResource(ha),
  fa = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("apiKey", "createdAt", "id", "liveUrlPrefix", "merchantAccount", "metadata", "name", "reference", "referenceOrigin", "updatedAt"), this.hasMany("adyenPayments", {
        className: "AdyenPayment"
      }), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      });
    }, t;
  }(x);
fa.className = "AdyenGateway";
var ya = A.createResource(fa),
  Aa = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("secretKey", "publicKey", "webhookEndpointId", "webhookEndpointSecret", "webhookEndpointUrl", "createdAt", "id", "metadata", "reference", "referenceOrigin", "updatedAt"), this.hasMany("checkoutComPayments", {
        className: "CheckoutComPayment"
      });
    }, t;
  }(x);
Aa.className = "CheckoutComGateway";
var Ca = A.createResource(Aa),
  xa = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("paymentType", "token", "sessionId", "sourceId", "customerToken", "redirectUri", "paymentResponse", "_authorize", "_details", "_refresh", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasOne("order", {
        className: "Order"
      }), this.hasOne("paymentGateway", {
        className: "PaymentGateway"
      });
    }, t;
  }(x);
xa.className = "CheckoutCom";
var ga = A.createResource(xa),
  Na = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("clientToken", "paymentMethodNonce", "options", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasMany("braintreePayments", {
        className: "BraintreePayment"
      }), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      });
    }, t;
  }(x);
Na.className = "BraintreeGateway";
var Oa = A.createResource(Na),
  va = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "credentials", "easypostId", "easypostType", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt"), this.hasMany("attachments", {
        className: "Attachment"
      });
    }, t;
  }(x);
va.className = "CarrierAccount";
var Ra = A.createResource(va),
  ka = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "requireCapture", "updatedAt"), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      });
    }, t;
  }(x);
ka.className = "ManualGateway";
var ba = A.createResource(ka),
  Pa = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("clientId", "clientSecret", "name", "id", "createdAt", "updatedAt", "reference", "referenceOrigin", "metadata"), this.hasMany("paypalPayments", {
        className: "PaypalPayment"
      }), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      });
    }, t;
  }(x);
Pa.className = "PaypalGateway";
var Sa = A.createResource(Pa),
  Ma = function (e) {
    function t() {
      return e.apply(this, arguments) || this;
    }
    return h(t, e), t.define = function () {
      this.attributes("createdAt", "id", "metadata", "name", "reference", "referenceOrigin", "updatedAt", "webhookEndpointId", "webhookEndpointSecret", "webhookEndpointUrl"), this.hasMany("stripePayments", {
        className: "StripePayment"
      }), this.hasMany("paymentMethods", {
        className: "PaymentMethod"
      });
    }, t;
  }(x);
Ma.className = "StripeGateway";
var Ia = A.createResource(Ma),
  La = {
    Address: N,
    Adjustment: nt,
    AdyenGateway: ya,
    AdyenPayment: Ze,
    Application: ca,
    Attachment: v,
    Authorization: ct,
    AvalaraAccount: na,
    BillingInfoValidationRule: lt,
    BraintreeGateway: Oa,
    BraintreePayment: Je,
    Capture: ot,
    CarrierAccount: Ra,
    CheckoutComGateway: Ca,
    CheckoutComPayment: ga,
    Coupon: Ct,
    CouponCodesPromotionRule: yt,
    Customer: F,
    CustomerAddress: k,
    CustomerGroup: P,
    CustomerPasswordReset: M,
    CustomerPaymentSource: L,
    CustomerSubscription: _,
    DeliveryLeadTime: q,
    ExternalGateway: ma,
    ExternalPayment: et,
    ExternalPromotion: gt,
    ExternalTaxCalculator: jt,
    FixedAmountPromotion: Ot,
    FreeShippingPromotion: Rt,
    Geocoder: je,
    GiftCard: We,
    GiftCardRecipient: Ve,
    Import: U,
    InStockSubscription: D,
    InventoryModel: z,
    InventoryReturnLocation: Gt,
    InventoryStockLocation: Le,
    LineItem: K,
    LineItemOption: H,
    ManualGateway: ba,
    ManualTaxCalculator: Et,
    Market: Q,
    Merchant: X,
    Order: $,
    OrderAmountPromotionRule: bt,
    Organization: oa,
    Package: at,
    Parcel: te,
    ParcelLineItem: pa,
    PaymentGateway: se,
    PaymentMethod: re,
    PaymentSource: Ee,
    PaypalGateway: Sa,
    PaypalPayment: ie,
    PercentageDiscountPromotion: St,
    Price: ue,
    PriceList: de,
    Promotion: Tt,
    PromotionRule: It,
    Refund: mt,
    Return: Bt,
    ReturnLineItem: Jt,
    Shipment: he,
    ShipmentLineItem: Yt,
    ShippingCategory: fe,
    ShippingMethod: Ae,
    ShippingZone: xe,
    Sku: ve,
    SkuList: ke,
    SkuListItem: Pe,
    SkuListPromotionRule: wt,
    SkuOption: Ne,
    StockItem: Me,
    StockLocation: _e,
    StockTransfer: aa,
    StripeGateway: Ia,
    StripePayment: Ye,
    TaxCalculator: Wt,
    TaxCategory: ea,
    TaxRule: Vt,
    TaxjarAccount: Zt,
    Transaction: la,
    Void: pt,
    Webhook: Fe,
    WireTransfer: qe,
    init: Be
  },
  Ta = Be;
exports.Address = N, exports.AddressCollection = g, exports.Adjustment = nt, exports.AdjustmentCollection = rt, exports.AdyenGateway = ya, exports.AdyenGatewayCollection = fa, exports.AdyenPayment = Ze, exports.AdyenPaymentCollection = Ke, exports.Application = ca, exports.ApplicationCollection = ia, exports.Attachment = v, exports.AttachmentCollection = O, exports.Authorization = ct, exports.AuthorizationCollection = it, exports.AvalaraAccount = na, exports.AvalaraAccountCollection = ra, exports.BillingInfoValidationRule = lt, exports.BillingInfoValidationRuleCollection = ut, exports.BraintreeGateway = Oa, exports.BraintreeGatewayCollection = Na, exports.BraintreePayment = Je, exports.BraintreePaymentCollection = Qe, exports.Capture = ot, exports.CaptureCollection = st, exports.CarrierAccount = Ra, exports.CarrierAccountCollection = va, exports.CheckoutComGateway = Ca, exports.CheckoutComGatewayCollection = Aa, exports.CheckoutComPayment = ga, exports.CheckoutComPaymentCollection = xa, exports.Coupon = Ct, exports.CouponCodesPromotionRule = yt, exports.CouponCodesPromotionRuleCollection = ft, exports.CouponCollection = At, exports.Customer = F, exports.CustomerAddress = k, exports.CustomerAddressCollection = R, exports.CustomerCollection = w, exports.CustomerGroup = P, exports.CustomerGroupCollection = b, exports.CustomerPasswordReset = M, exports.CustomerPasswordResetCollection = S, exports.CustomerPaymentSource = L, exports.CustomerPaymentSourceCollection = I, exports.CustomerSubscription = _, exports.CustomerSubscriptionCollection = T, exports.DeliveryLeadTime = q, exports.DeliveryLeadTimeCollection = G, exports.ExternalGateway = ma, exports.ExternalGatewayCollection = da, exports.ExternalPayment = et, exports.ExternalPaymentCollection = $e, exports.ExternalPromotion = gt, exports.ExternalPromotionCollection = xt, exports.ExternalTaxCalculator = jt, exports.ExternalTaxCalculatorCollection = Ut, exports.FixedAmountPromotion = Ot, exports.FixedAmountPromotionCollection = Nt, exports.FreeShippingPromotion = Rt, exports.FreeShippingPromotionCollection = vt, exports.Geocoder = je, exports.GeocoderCollection = Ue, exports.GiftCard = We, exports.GiftCardCollection = ze, exports.GiftCardRecipient = Ve, exports.GiftCardRecipientCollection = He, exports.Import = U, exports.ImportCollection = B, exports.InStockSubscription = D, exports.InStockSubscriptionCollection = j, exports.InventoryModel = z, exports.InventoryModelCollection = E, exports.InventoryReturnLocation = Gt, exports.InventoryReturnLocationCollection = Ft, exports.InventoryStockLocation = Le, exports.InventoryStockLocationCollection = Ie, exports.LineItem = K, exports.LineItemCollection = V, exports.LineItemOption = H, exports.LineItemOptionCollection = W, exports.ManualGateway = ba, exports.ManualGatewayCollection = ka, exports.ManualTaxCalculator = Et, exports.ManualTaxCalculatorCollection = Dt, exports.Market = Q, exports.MarketCollection = Z, exports.Merchant = X, exports.MerchantCollection = J, exports.Order = $, exports.OrderAmountPromotionRule = bt, exports.OrderAmountPromotionRuleCollection = kt, exports.OrderCollection = Y, exports.Organization = oa, exports.OrganizationCollection = sa, exports.Package = at, exports.PackageCollection = tt, exports.Parcel = te, exports.ParcelCollection = ee, exports.ParcelLineItem = pa, exports.ParcelLineItemCollection = ha, exports.PaymentGateway = se, exports.PaymentGatewayCollection = ne, exports.PaymentMethod = re, exports.PaymentMethodCollection = ae, exports.PaymentSource = Ee, exports.PaymentSourceCollection = De, exports.PaypalGateway = Sa, exports.PaypalPayment = ie, exports.PaypalPaymentCollection = oe, exports.PercentageDiscountPromotion = St, exports.PercentageDiscountPromotionCollection = Pt, exports.Price = ue, exports.PriceCollection = ce, exports.PriceList = de, exports.PriceListCollection = le, exports.Promotion = Tt, exports.PromotionCollection = Lt, exports.PromotionRule = It, exports.PromotionRuleCollection = Mt, exports.Refund = mt, exports.RefundCollection = dt, exports.Return = Bt, exports.ReturnCollection = qt, exports.ReturnLineItem = Jt, exports.ReturnLineItemCollection = Qt, exports.Shipment = he, exports.ShipmentCollection = me, exports.ShipmentLineItem = Yt, exports.ShipmentLineItemCollection = Xt, exports.ShippingCategory = fe, exports.ShippingCategoryCollection = pe, exports.ShippingMethod = Ae, exports.ShippingMethodCollection = ye, exports.ShippingZone = xe, exports.ShippingZoneCollection = Ce, exports.Sku = ve, exports.SkuCollection = Oe, exports.SkuList = ke, exports.SkuListCollection = Re, exports.SkuListItem = Pe, exports.SkuListItemCollection = be, exports.SkuListPromotionRule = wt, exports.SkuListPromotionRuleCollection = _t, exports.SkuOption = Ne, exports.SkuOptionCollection = ge, exports.StockItem = Me, exports.StockItemCollection = Se, exports.StockLocation = _e, exports.StockLocationCollection = Te, exports.StockTransfer = aa, exports.StockTransferCollection = ta, exports.StripeGateway = Ia, exports.StripePayment = Ye, exports.StripePaymentCollection = Xe, exports.TaxCalculator = Wt, exports.TaxCalculatorCollection = zt, exports.TaxCategory = ea, exports.TaxCategoryCollection = $t, exports.TaxRule = Vt, exports.TaxRuleCollection = Ht, exports.TaxjarAccount = Zt, exports.TaxjarAccountCollection = Kt, exports.Transaction = la, exports.TransactionCollection = ua, exports.Void = pt, exports.VoidCollection = ht, exports.Webhook = Fe, exports.WebhookCollection = we, exports.WireTransfer = qe, exports.WireTransferCollection = Ge, exports.default = La, exports.initCLayer = Ta;